import { Injectable } from '@angular/core';

@Injectable()
export class TraconOperations {
    airCarrier: boolean;
    airTaxi: boolean;
    generalAviation: boolean;
    military: boolean;
    totalOverflights: boolean;
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tracon-models/tracon-operations.ts
 **/